import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
import useCheckScreenSize from "../../utils/checkScreenSize";
import "../../components/styles.css";
import { useTranslation } from "react-i18next";

export const ClaimsFooter: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useCheckScreenSize({ breakpoint: 800 });
  return (
    <div className="footerContainer">
      <Container maxWidth="lg">
        <div
          className={classNames(!isMobile && "row footerText", "footerLinks")}
        >
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/about-pge/company-information/diversity-and-inclusion/accessibility/accessibility.page"
            >
              {t('Accessibility')}
            </a>
          </div>
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/about-pge/company-information/disclosure/disclosure.page?"
            >
              {t('TermsAndConditions')}
            </a>
          </div>
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/about-pge/company-information/regulation/regulation.page"
            >
              {t('Regulation')}
            </a>
          </div>
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/about-pge/company-information/privacy-policy/privacy.page"
            >
              {t('Privacy')}
            </a>
          </div>
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/about-pge/company-information/security/security.page"
            >
              {t('Security')}
            </a>
          </div>
          <div className="footerLinksPadding">
            <button
              className="secondButton ot-sdk-show-settings"
              id="cookie_settings ot-sdk-btn"
            >
              {t('DoNotSellMyPersonalInformation')}
            </button>           
          </div>
          <div className="footerLinksPadding">
            <a
              className="secondButton"
              href="https://www.pge.com/en_US/sitemap.page?"
            >
              {t('SiteMap')}
            </a>
          </div>
        </div>       
        <Typography variant="caption" color="initial" className="mobileBar">
          ©{new Date().getFullYear()} {t('CopyrightText')}
        </Typography>
      </Container>
    </div>    
  );
};